import WordCreate from './views/WordCreate.vue';
import WordList from './views/WordList.vue';
import Word from './Root.vue';

export default {
  path: 'palavra/',
  component: Word,
  name: 'admin-word',
  redirect: '/palavras/novo',
  children: [
    {
      path: 'lista/:page',
      name: 'admin-word-list',
      component: WordList,
    },
    {
      path: 'novo',
      name: 'admin-word-new',
      component: WordCreate,
    },
  ],
};
